export default {
  colorItem: {
    single: '单色',
    gradient: '渐变色',
  },
  alignment: {
    ar: '阿拉伯语不支持两端对齐',
    my: '缅甸语不支持两端对齐',
  },
  textNode: {
    title: '文本对齐方式',
  },
  textStyleShadow: {
    shadowBlur: '模糊',
    title: '阴影',
  },
  textStyleSize: {
    fontSize: '字号',
    letterSpacing: '字距',
    lineHeight: '行高',
    bold: '粗体',
    italic: '斜体',
    underline: '下划线',
    strikethrough: '删除线',
  },
  textStyleStroke: {
    title: '描边',
  },
  textStyle: {
    applyToOtherLanguage: '应用到其他语言',
    languageMessage: ['没有其他语言', '应用样式到其他语言成功'],
  },
}
